// Subscription entitlements (spec/14-hq-console.md §4.1, spec/01-glossary.md).
//
// A capability, limit or feature switch that an organisation's plan, or an add-on (spec/14 §4.5), unlocks. A setting may name
// one, and endpoints that need one return `402 entitlement-required` without it (spec/18 §2).
// Entitlements are enforced in one place, in the `hq.entitlements` service (spec/14 §4.2); this is
// only the list of names, so that a setting cannot point at an entitlement that does not exist.
export const ENTITLEMENT_KEYS = [
    'fnb',
    'inventory',
    'manualStations',
    'wallet',
    'memberships',
    'reservations',
    'loyaltyVenueRewards',
    'apiAccess',
    'webhooks',
    'maxVenues',
    'maxStations',
    'remoteControl',
    'advancedReports',
    // Clavian Boot (spec/25 §17, ADR-0063 decision 13): sold per PC as a provider-priced add-on, not in a plan.
    // `boot` is held with an active `boot` add-on; `maxBootPcs` is its quantity, the PCs the boot server may boot.
    'boot',
    'maxBootPcs',
];
export function isEntitlementKey(value) {
    return typeof value === 'string' && ENTITLEMENT_KEYS.includes(value);
}
//# sourceMappingURL=entitlements.js.map